import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './authorize.service'; // Importieren Sie Ihren AuthService

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const gesendet = this.mitToken(req);

    return next.handle(gesendet).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status !== 401) {
          return throwError(error);
        }

        /*
         * Das Refresh selbst darf hier nicht landen – sonst entstünde bei
         * einem abgelehnten Refresh-Token eine Endlosschleife.
         */
        if (this.istAnmeldeAufruf(req)) {
          this.beendeSitzung();
          return throwError(error);
        }

        /*
         * Ein 401 nach längerer Arbeit ohne Netz ist der Normalfall: das JWT
         * lebt 30 Minuten, der Einsatz auf der Anlage dauert länger. Solange
         * ein brauchbares Refresh-Token vorliegt, wird die Sitzung deshalb
         * ERNEUERT statt beendet – und die ursprüngliche Anfrage einmal
         * wiederholt.
         *
         * Ohne das stünde der Monteur nach jeder Rückkehr in den Empfang vor
         * dem Anmeldebildschirm, obwohl seine Anmeldung noch gültig ist.
         */
        if (!this.authService.kannSitzungErneuern()) {
          this.beendeSitzung();
          return throwError(error);
        }

        return this.authService.refreshTokenGeteilt().pipe(

          // Mit dem frischen Token noch einmal – diesmal ohne weiteren
          // Rettungsversuch, damit es bei einem echten 401 hier endet.
          switchMap(() => next.handle(this.mitToken(req))),

          catchError(refreshFehler => {
            /*
             * Hat der Server das Refresh-Token abgelehnt, hat AuthService
             * bereits abgemeldet. War es nur das Netz, bleibt die Sitzung
             * bestehen und der Aufrufer bekommt seinen Fehler – bei der
             * Inbetriebnahme greift dann der Offline-Fallback.
             */
            return throwError(refreshFehler);
          })
        );
      })
    );
  }

  /** Hängt das aktuelle Token an, sofern eines vorliegt. */
  private mitToken(req: HttpRequest<any>): HttpRequest<any> {
    const token = localStorage.getItem('token');

    if (!token) {
      return req;
    }

    return req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  /** Anmeldung und Token-Erneuerung – bei denen darf nicht nachgefasst werden. */
  private istAnmeldeAufruf(req: HttpRequest<any>): boolean {
    return req.url.includes('/account/refresh-token')
      || req.url.includes('/account/login');
  }

  private beendeSitzung(): void {
    this.authService.logout();
    this.router.navigate(['users/login']);
  }
}
